import { ref, watchEffect } from 'vue'

export function useVMin(input: number | string) {
  const vminValue = ref('')

  watchEffect(() => {
    // 获取窗口宽度和高度
    const width = window.innerWidth
    const height = window.innerHeight
    const vmax = Math.max(width, height) / 100 // 1vmin 对应的较长边

    let pxValue = 0

    // 判断输入是数字还是字符串
    if (typeof input === 'number') {
      pxValue = input // 如果是数字，直接使用
    } else if (typeof input === 'string') {
      // 如果是字符串，提取数字部分
      pxValue = Number.parseFloat(input)
    }

    // 转换为 vmin 单位
    const result = pxValue / vmax
    vminValue.value = `${result}vmin`
  })

  return vminValue
}
